// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__1ehKd","Hero-verticallyCenter":"Hero_Hero-verticallyCenter__FD5o4"};